import styled from 'styled-components'
export const Wrapper = styled.div`
  h1 {
    text-align: center;
    font-size: 36px;
  }
  margin-bottom: 80px;
`
